import { Search, Shield, Globe, AlertCircle, Building2, Key } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import ScanPrompt from '../../components/LandingPage/ScanPrompt'; // 📌 Importar el nuevo componente
import { ServiceCard } from './ServiceCard';

export function ServicesSection() {
  const { t } = useTranslation();

  const services = [
    { icon: Building2, title: t('home.services.business_intelligence_title'), description: t('home.services.business_intelligence_description') },
    { icon: Key, title: t('home.services.credential_monitoring_title'), description: t('home.services.credential_monitoring_description') },
    { icon: Globe, title: t('home.services.domain_analysis_title'), description: t('home.services.domain_analysis_description') },
    { icon: Search, title: t('home.services.web_analysis_title'), description: t('home.services.web_analysis_description') },
    { icon: AlertCircle, title: t('home.services.impersonation_detection_title'), description: t('home.services.impersonation_detection_description') },
    { icon: Shield, title: t('home.services.security_assessments_title'), description: t('home.services.security_assessments_description') },
  ];

  return (
    <section className="w-full">
      <div className="container mx-auto px-4 md:px-6 max-w-6xl">
        
        <ScanPrompt />

        <div className="mt-10 mb-12 px-4 text-center">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4 leading-snug">
            {t('home.services_title')}
          </h2>
          <p className="text-sm sm:text-base md:text-lg lg:text-xl text-gray-400 max-w-md sm:max-w-lg md:max-w-xl mx-auto leading-relaxed">
            {t('home.services_subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service) => (
            <div key={service.title} className="animate-fade-in h-full">
              <ServiceCard icon={service.icon} title={service.title} description={service.description} />
            </div>
          ))}
        </div>


      </div>
    </section>
  );
}
